soundManager.setup({debugMode:!1,preferFlash:!0,useFlashBlock:!1}),soundManager.onready(function(){new InlinePlayer});